import React from 'react';
const PINES = [{
  x: 96,
  y: 300,
  s: 1
}, {
  x: 132,
  y: 336,
  s: 0.8
}, {
  x: 214,
  y: 128,
  s: 0.9
}, {
  x: 258,
  y: 96,
  s: 0.7
}, {
  x: 470,
  y: 344,
  s: 1
}, {
  x: 520,
  y: 308,
  s: 0.8
}, {
  x: 556,
  y: 116,
  s: 0.9
}, {
  x: 74,
  y: 152,
  s: 0.75
}, {
  x: 402,
  y: 84,
  s: 0.7
}, {
  x: 318,
  y: 404,
  s: 0.85
}];
function Pine({
  x,
  y,
  s
}: {
  x: number;
  y: number;
  s: number;
}) {
  return <g transform={`translate(${x} ${y}) scale(${s})`} opacity="0.5" data-id="element-388" data-mp="19urrunlmkg1p">
      <path d="M0 -26 L13 4 L-13 4 Z" fill="#2F4A3A" data-id="element-389" data-mp="19seyzfebwl9v" />
      <path d="M0 -12 L16 18 L-16 18 Z" fill="#2F4A3A" data-id="element-390" data-mp="1eue1kn28ve5r" />
      <rect x="-2" y="18" width="4" height="9" fill="#6B4A33" data-id="element-391" data-mp="1jsfnrguyvtlg" />
    </g>;
}

/**
 * Hand-drawn style map of where the retreat sits — the marker is the only
 * thing in colour so the eye lands on Kfar Pines first, with drive times
 * hanging off the roads that reach it.
 */
export function IllustratedMap() {
  return <svg viewBox="0 0 640 480" role="img" aria-label="Illustrated map showing Pines Retreat in Kfar Pines, 45 minutes from Tel Aviv, 35 minutes from Haifa and 8 minutes from Pardes Hanna" className="h-auto w-full" data-id="element-392" data-mp="w2bmvh95y7y5">
      <rect width="640" height="480" fill="#EDE4D0" data-id="element-393" data-mp="13dwngbi26vsh" />

      {/* soft land masses */}
      <path d="M-20 330 C 90 296 180 358 270 336 C 372 310 460 366 660 330 L660 500 L-20 500 Z" fill="#2F4A3A" opacity="0.07" data-id="element-394" data-mp="ykv67wudqk5q" />
      <path d="M-20 118 C 110 92 190 142 300 116 C 420 88 530 130 660 100 L660 -20 L-20 -20 Z" fill="#2F4A3A" opacity="0.05" data-id="element-395" data-mp="pm9fheer7ytv" />

      {/* roads */}
      <g fill="none" strokeLinecap="round" data-id="element-396" data-mp="kozqfzva1p6k">
        <path d="M150 104 C 196 168 238 200 312 238" stroke="#D9C9A8" strokeWidth="11" data-id="element-397" data-mp="foli0gprkd80" />
        <path d="M204 404 C 244 336 268 292 312 250" stroke="#D9C9A8" strokeWidth="11" data-id="element-398" data-mp="bmqldpis2o0k" />
        <path d="M516 214 C 448 216 396 226 330 240" stroke="#D9C9A8" strokeWidth="11" data-id="element-399" data-mp="2a2392dpdns7s" />
        <path d="M150 104 C 196 168 238 200 312 238" stroke="#F5EFE2" strokeWidth="1.5" strokeDasharray="7 9" data-id="element-400" data-mp="2609dukxybgf0" />
        <path d="M204 404 C 244 336 268 292 312 250" stroke="#F5EFE2" strokeWidth="1.5" strokeDasharray="7 9" data-id="element-401" data-mp="3bzzllp2agbb" />
        <path d="M516 214 C 448 216 396 226 330 240" stroke="#F5EFE2" strokeWidth="1.5" strokeDasharray="7 9" data-id="element-402" data-mp="3qitok5k53loi" />
      </g>

      {PINES.map(pine => <Pine key={`${pine.x}-${pine.y}`} {...pine} data-id="element-403" data-mp="m3kb1ax2c81i" />)}

      {/* city nodes */}
      <g fontFamily="Inter, sans-serif" data-id="element-404" data-mp="r3f2bfkr2zn3">
        <g data-id="element-405" data-mp="r242fqufec19">
          <circle cx="150" cy="104" r="6" fill="#6B4A33" data-id="element-406" data-mp="r0swplhf6u7i" />
          <text x="150" y="76" textAnchor="middle" fontSize="19" fill="#2F4A3A" fontWeight="500" data-id="element-407" data-mp="d22r1hgjbm7j">
            Haifa
          </text>
          <text x="150" y="56" textAnchor="middle" fontSize="14" fill="#8A6A4E" data-id="element-408" data-mp="i0e2fwmha4rv">
            35 min
          </text>
        </g>
        <g data-id="element-409" data-mp="32sg16sci2b09">
          <circle cx="204" cy="404" r="6" fill="#6B4A33" data-id="element-410" data-mp="32szbpnztlx49" />
          <text x="204" y="440" textAnchor="middle" fontSize="19" fill="#2F4A3A" fontWeight="500" data-id="element-411" data-mp="32qd3dm53vdkz">
            Tel Aviv
          </text>
          <text x="204" y="460" textAnchor="middle" fontSize="14" fill="#8A6A4E" data-id="element-412" data-mp="2qadfha0g0rcm">
            45 min
          </text>
        </g>
        <g data-id="element-413" data-mp="348aeed2dd9ug">
          <circle cx="516" cy="214" r="6" fill="#6B4A33" data-id="element-414" data-mp="3493e4u2wuz33" />
          <text x="546" y="200" textAnchor="middle" fontSize="19" fill="#2F4A3A" fontWeight="500" data-id="element-415" data-mp="2za0k04ogyd9w">
            Pardes Hanna
          </text>
          <text x="546" y="220" textAnchor="middle" fontSize="14" fill="#8A6A4E" data-id="element-416" data-mp="2blh7te2atgcj">
            8 min
          </text>
        </g>
      </g>

      {/* the retreat */}
      <g data-id="element-417" data-mp="2lb0u6tp7zsc5">
        <circle cx="318" cy="244" r="30" fill="#C2542A" opacity="0.14" data-id="element-418" data-mp="2lbspe3ewno1w" />
        <circle cx="318" cy="244" r="13" fill="#C2542A" data-id="element-419" data-mp="2gkao1e8yzlge" />
        <circle cx="318" cy="244" r="4.5" fill="#F5EFE2" data-id="element-420" data-mp="2gipv1t2b0akn" />
        <text x="318" y="296" textAnchor="middle" fontFamily="Fraunces, serif" fontSize="25" fill="#2F4A3A" data-id="element-421" data-mp="1stofzmyyu16e">
          Kfar Pines
        </text>
        <text x="318" y="318" textAnchor="middle" fontFamily="Inter, sans-serif" fontSize="13" letterSpacing="2.4" fill="#8A6A4E" data-id="element-422" data-mp="r59oq68dwfzm">
          PINES RETREAT
        </text>
      </g>
    </svg>;
}